import React from "react";

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-black text-white px-6 py-16">
      <div className="max-w-5xl mx-auto space-y-10">
        <header className="space-y-5">
          <p className="text-sm uppercase tracking-[0.3em] text-zinc-400">
            Confidentialité
          </p>
          <h1 className="text-4xl md:text-6xl font-bold leading-tight">
            Politique de confidentialité
          </h1>
          <p className="text-zinc-300 text-lg leading-8">
            La présente politique de confidentialité a pour objectif de vous
            informer de manière claire sur la manière dont vos données peuvent
            être collectées, utilisées, conservées et protégées lors de
            l’utilisation du site et du jeu AI Startup Clicker.
          </p>
          <p className="text-zinc-300 leading-8">
            Nous accordons de l’importance à la protection de vos données
            personnelles et nous nous efforçons de limiter la collecte aux
            informations strictement nécessaires au fonctionnement du service,
            à l’amélioration de l’expérience utilisateur, à la sécurité du site
            et, le cas échéant, à la diffusion de contenus publicitaires.
          </p>
        </header>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold">1. Données pouvant être collectées</h2>
          <p className="text-zinc-300 leading-8">
            Selon votre utilisation du site, nous pouvons être amenés à traiter
            différentes catégories de données, notamment :
          </p>
          <ul className="list-disc pl-6 text-zinc-300 space-y-3 leading-8">
            <li>des données de compte, comme une adresse e-mail ;</li>
            <li>des données techniques, comme l’adresse IP, le navigateur, le type d’appareil ou les journaux d’accès ;</li>
            <li>des données liées à l’utilisation du jeu, comme votre progression, vos scores, vos statistiques ou votre position au classement ;</li>
            <li>des données de mesure d’audience et de navigation ;</li>
            <li>des données relatives au consentement ou aux préférences de confidentialité ;</li>
            <li>des données issues de cookies ou technologies similaires, selon votre choix et la configuration du site.</li>
          </ul>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold">2. Finalités du traitement</h2>
          <p className="text-zinc-300 leading-8">
            Les données peuvent être utilisées pour les finalités suivantes :
          </p>
          <ul className="list-disc pl-6 text-zinc-300 space-y-3 leading-8">
            <li>permettre la création et la gestion des comptes utilisateurs ;</li>
            <li>assurer le fonctionnement du jeu et l’enregistrement de la progression ;</li>
            <li>afficher des classements et fonctionnalités compétitives ;</li>
            <li>sécuriser le site, détecter les abus, la fraude ou la triche ;</li>
            <li>mesurer la fréquentation et améliorer les performances du service ;</li>
            <li>répondre aux demandes de contact ou d’assistance ;</li>
            <li>respecter les obligations légales ;</li>
            <li>
              le cas échéant, afficher de la publicité, mesurer son efficacité
              et adapter certains contenus publicitaires selon les règles
              applicables et les choix de consentement.
            </li>
          </ul>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold">3. Base juridique</h2>
          <p className="text-zinc-300 leading-8">
            Les traitements de données peuvent reposer sur différentes bases
            juridiques selon leur nature, notamment :
          </p>
          <ul className="list-disc pl-6 text-zinc-300 space-y-3 leading-8">
            <li>l’exécution du service demandé par l’utilisateur ;</li>
            <li>l’intérêt légitime lié à la sécurité, à l’amélioration du service et à la prévention de la fraude ;</li>
            <li>le respect d’obligations légales ;</li>
            <li>le consentement, notamment lorsque celui-ci est requis pour certains cookies ou traitements publicitaires.</li>
          </ul>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold">4. Cookies et traceurs</h2>
          <p className="text-zinc-300 leading-8">
            Le site peut utiliser des cookies ou technologies similaires pour
            assurer son bon fonctionnement, mémoriser certaines préférences,
            mesurer l’audience, améliorer l’expérience utilisateur et, le cas
            échéant, afficher des annonces publicitaires.
          </p>
          <p className="text-zinc-300 leading-8">
            Certains cookies peuvent être strictement nécessaires au
            fonctionnement technique du site. D’autres, notamment ceux liés à la
            mesure d’audience ou à la publicité personnalisée, peuvent nécessiter
            votre consentement selon la réglementation applicable dans votre
            pays ou votre zone géographique.
          </p>
          <p className="text-zinc-300 leading-8">
            Vous pouvez à tout moment gérer vos préférences de cookies via les
            outils mis à votre disposition sur le site, lorsqu’ils sont présents,
            ou via les paramètres de votre navigateur.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold">5. Publicité et Google AdSense</h2>
          <p className="text-zinc-300 leading-8">
            Le site peut utiliser des partenaires publicitaires, y compris
            Google AdSense, afin d’afficher des annonces. Ces partenaires
            peuvent utiliser des cookies ou identifiants similaires pour servir
            des publicités, limiter la répétition des annonces, mesurer les
            performances ou, selon les cas autorisés, personnaliser les contenus
            publicitaires.
          </p>
          <p className="text-zinc-300 leading-8">
            Lorsque cela est applicable, les utilisateurs situés dans certaines
            zones, notamment l’Espace économique européen, le Royaume-Uni ou la
            Suisse, peuvent se voir proposer un mécanisme de gestion du
            consentement pour choisir l’utilisation de certaines technologies
            publicitaires.
          </p>
          <p className="text-zinc-300 leading-8">
            Des fournisseurs tiers, y compris Google, peuvent utiliser des
            cookies pour diffuser des annonces en fonction des visites
            antérieures d’un utilisateur sur ce site ou sur d’autres sites.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold">6. Destinataires des données</h2>
          <p className="text-zinc-300 leading-8">
            Les données traitées peuvent être accessibles, dans la limite de ce
            qui est nécessaire, à :
          </p>
          <ul className="list-disc pl-6 text-zinc-300 space-y-3 leading-8">
            <li>l’éditeur du site et les personnes habilitées à le gérer ;</li>
            <li>les prestataires techniques participant à l’hébergement, à la base de données, à la sécurité ou au bon fonctionnement du service ;</li>
            <li>les fournisseurs de mesure d’audience ;</li>
            <li>les partenaires publicitaires, sous réserve des réglages applicables ;</li>
            <li>les autorités administratives ou judiciaires lorsque la loi l’exige.</li>
          </ul>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold">7. Durée de conservation</h2>
          <p className="text-zinc-300 leading-8">
            Les données sont conservées pendant une durée proportionnée à leur
            finalité. Certaines données peuvent être conservées tant que le
            compte reste actif. D’autres peuvent être supprimées plus rapidement
            ou archivées pour une durée plus longue lorsque cela est nécessaire
            pour répondre à des obligations légales, comptables, fiscales,
            sécuritaires ou probatoires.
          </p>
          <p className="text-zinc-300 leading-8">
            Les cookies ont une durée de vie variable selon leur nature. Les
            préférences et consentements peuvent également être conservés pour
            prouver le respect des obligations applicables.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold">8. Sécurité</h2>
          <p className="text-zinc-300 leading-8">
            Nous mettons en œuvre des mesures techniques et organisationnelles
            raisonnables afin de protéger les données contre l’accès non
            autorisé, la divulgation, l’altération, la perte ou la destruction.
            Toutefois, aucun système n’étant totalement infaillible, une
            sécurité absolue ne peut être garantie.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold">9. Vos droits</h2>
          <p className="text-zinc-300 leading-8">
            Selon la réglementation applicable, vous pouvez disposer de droits
            relatifs à vos données personnelles, notamment :
          </p>
          <ul className="list-disc pl-6 text-zinc-300 space-y-3 leading-8">
            <li>droit d’accès ;</li>
            <li>droit de rectification ;</li>
            <li>droit d’effacement ;</li>
            <li>droit à la limitation ;</li>
            <li>droit d’opposition, lorsque cela s’applique ;</li>
            <li>droit à la portabilité, lorsque cela s’applique ;</li>
            <li>droit de retirer votre consentement à tout moment pour les traitements fondés sur celui-ci.</li>
          </ul>
          <p className="text-zinc-300 leading-8">
            Pour exercer vos droits, vous pouvez utiliser les coordonnées
            indiquées sur la page de contact ou dans les mentions légales, en
            joignant tout élément utile permettant de traiter votre demande.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold">10. Données des mineurs</h2>
          <p className="text-zinc-300 leading-8">
            Le site n’a pas vocation à collecter volontairement des données
            personnelles auprès de très jeunes enfants sans cadre légal adapté.
            Si vous estimez qu’une donnée a été fournie de manière inappropriée,
            vous pouvez contacter l’éditeur afin qu’une vérification soit
            effectuée.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold">11. Modifications de la politique</h2>
          <p className="text-zinc-300 leading-8">
            La présente politique de confidentialité peut être modifiée à tout
            moment pour tenir compte d’évolutions techniques, légales ou
            fonctionnelles. La version publiée sur le site est celle
            applicable au moment de votre consultation.
          </p>
        </section>

        <footer className="pt-6 border-t border-zinc-800">
          <p className="text-zinc-400 leading-7">
            Dernière mise à jour : à compléter selon la date de publication
            effective.
          </p>
        </footer>
      </div>
    </div>
  );
}